import { useState, useEffect } from "react";
import Heart from "./Heart";
import { FaHeart } from "react-icons/fa";
import type { IconType } from "react-icons";
import Pusher from "pusher-js";
import { PlayerMeta, PusherConfig } from "@/types";
import { useAnalytics } from "@/lib/AnalyticsContext";

export interface HeartButtonProps {
  pusher: Pusher | null;
  pusherConfig: PusherConfig | null;
  meta: PlayerMeta;
  onHeartSend: (meta: PlayerMeta) => Promise<void>;
}

const HeartIcon: IconType = FaHeart;

const HeartButton = ({
  pusher,
  pusherConfig,
  meta,
  onHeartSend,
}: HeartButtonProps) => {
  const [timestamps, setTimestamps] = useState<number[]>([]);
  const [disabled, setDisabled] = useState<boolean>(false);
  const analytics = useAnalytics();

  const addHeart = () => {
    setTimestamps((s) => [...s.slice(-20), Date.now()]);
  };
  const sendHeart = async () => {
    if (!disabled) {
      setDisabled(true);
      await onHeartSend(meta);
      analytics.sendLiveCommerceEvent.heart(meta.id, meta.userId);
      setTimeout(() => {
        setDisabled(false);
      }, 1000);
    }
  };
  useEffect(() => {
    if (!pusher || !pusherConfig) return;

    const prefix = pusherConfig.prefix + "-";
    const channelName = prefix + "viewer-channel";
    const eventName = prefix + "heart-event";

    let channel = pusher.channel(channelName);
    if (!channel) {
      channel = pusher.subscribe(channelName);
    }

    const handler = (data: any) => {
      addHeart();
    };

    channel.bind(eventName, handler);

    // クリーンアップ関数
    return () => {
      try {
        channel.unbind(eventName, handler);
      } catch {}
      // NOTE: 他インスタンスが存在する可能性があるため、チャンネル自体は解除しない
    };
  }, [pusher, pusherConfig]);

  return (
    <div className="tw-relative tw-flex tw-items-center tw-justify-center">
      <FaHeart
        className={`tw-text-pink-400 tw-border-none tw-bg-transparent tw-p-0 tw-cursor-pointer ${disabled ? "tw-opacity-50" : ""}`}
        onClick={sendHeart}
        aria-label="send heart"
        size="1.2rem"
      />
      {timestamps.map((t) => (
        <Heart key={t} data-testid="floating-heart" />
      ))}
    </div>
  );
};

export default HeartButton;
